import ProductPricingTable from "./ProductPricingTable";
export default ProductPricingTable;
